// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__jC","cls2":"AccountMenuButton-cls2_Ip7 AccountMenuButton-cls1__jC"};